import { render, staticRenderFns } from "./CreditOrdererTypeView.vue?vue&type=template&id=46a5da15"
import script from "./CreditOrdererTypeView.vue?vue&type=script&lang=js"
export * from "./CreditOrdererTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports